module.exports = __webpack_public_path__ + "img/btn-evening.1c403ad2.png";